import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import RodzajeKalendarzyContainer from "./rodzajeKalendarzy/RodzajeKalendarzyContainer";
import KalendarzDoDatyContainer from "./przypisanieKalendarzaDoDaty/KalendarzDoDatyContainer";
import FerieContainer from "./ferie/FerieContainer";

export default class KalendarzeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
        };
        this.changeActiveTab = this.changeActiveTab.bind(this)
    }

    renderContent(){
        if(this.state.activeTab === 1){
            return <KalendarzDoDatyContainer/>
        }
        else if(this.state.activeTab ===2){
            return <RodzajeKalendarzyContainer/>
        }
        else{
            return <FerieContainer/>
        }
    }

    changeActiveTab(eventKey){
        this.setState({activeTab:eventKey})
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieTrasamiContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {addressUrl: '/konfiguracja/rozklad-jazdy', text: 'Rozkład jazdy'},{addressUrl: '/konfiguracja/rozklad-jazdy/kalendarze', text: 'Kalendarze'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz} history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <Tabs defaultActiveKey={1} id="ekipy-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="Wybór kalendarza do daty" >
                                </Tab>
                                <Tab eventKey={2} title="Rodzaje kalendarzy">
                                </Tab>
                                <Tab eventKey={3} title="Ferie">
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop:'15px'}}>
                                {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/KalendarzeContainer.js